<template>
  <div class="main_content admin">
    <div class="">
      <div class="float-right mb-3">
        <button style="margin-right: 15px;" class="secondary_btn" @click="delSelected">批量删除</button>
        <button class="primary_btn" @click="newRecord">新建</button>
      </div>
    </div>
    <table class="table table-striped table-responsive-sm table-hover green_table">
      <thead>
      <tr>
        <th>
          <b-link href="#" style="font-size: 12px; padding-right: 10px;" @click="selectAll">全选</b-link>
          <b-link href="#" style="font-size: 12px;" @click="shiftAll">反选</b-link>
        </th>
        <th scope="col">id</th>
        <th scope="col">IMEI</th>
        <th scope="col">省份</th>
        <th scope="col">市</th>
        <th scope="col">县</th>
        <th scope="col">片区</th>
        <th scope="col">村寨</th>
        <th scope="col">位置</th>
        <th scope="col">用途</th>
        <th scope="col">经度</th>
        <th scope="col">纬度</th>
        <th scope="col">操作</th>
      </tr>
      </thead>
      <tbody>
      <template v-for="(item, index) in cameraData.records">
        <tr v-bind:key="item.id">
          <td>
            <b-form-checkbox style="display: flex;"
                             v-model="item.selected">
            </b-form-checkbox>
          </td>
          <td>{{ item.id }}</td>
          <td>
            <b-form-input v-model="item.imei"/>
          </td>
          <td>
            <b-form-select v-model="item.province" :options="provinceData"
                           @change="loadItemCityData(item)"/>
          </td>
          <td>
            <b-form-select v-model="item.city" :options="item.cityData"
                           @change="loadItemCountyData(item)"/>
          </td>
          <td>
            <b-form-select v-model="item.county" :options="item.countyData"
                           @change="loadItemTownData(item)"/>
          </td>
          <td>
            <b-form-select v-model="item.town" :options="item.townData"
                           @change="changeTown(item)"/>
          </td>
          <td>
            <b-form-input v-model="item.village"/>
          </td>
          <td>
            <b-form-input v-model="item.place"/>
          </td>
          <td>
            <b-form-select v-model="item.scope" :options="scopeData"/>
          </td>
          <td>
            <b-form-input v-model.number="item.lon" :min="-180" :max="180"/>
          </td>
          <td>
            <b-form-input v-model.number="item.lat" :min="-90" :max="90"/>
          </td>
          <td>
            <b-link @click.stop="save(item)" style="padding-right: 15px;">保存</b-link>
            <b-link @click.stop="delOne(item, index)">删除</b-link>
          </td>
        </tr>
      </template>
      </tbody>
    </table>
    <b-pagination v-model="cameraData.page_no" :total-rows="cameraData.total"
                  :per-page="cameraData.page_size" @change="pageChange" first-text="第一页"
                  prev-text="上一页" next-text="下一页" last-text="最后一页"></b-pagination>
  </div>
</template>
<script>
import PlaceApi from '../../api/place'
import CameraApi from '../../api/camera'
import Tool from '../../util/tool'

export default {
  data () {
    return {
      param: {
        page_no: 1,
        page_size: 10
      },
      cameraData: {
        records: [],
        total: 0,
        page_no: 1,
        page_size: 10
      },
      selectedOption: {},
      provinceData: [],
      provinceMap: {},

      cityData: [],
      cityMap: {},
      countyMap: {},

      scopeData: [
        {
          value: 1,
          text: '物种监测'
        },
        {
          value: 2,
          text: '物候监测'
        }
      ]
    }
  },
  components: {},
  computed: {
    countyCodeOption () {
      let list = []
      this.$store.getters.county_code_list.forEach(item => {
        list.push({ text: item.name, value: item.code })
      })
      return list
    }
  },
  mounted () {
    this.loadCityList().then(r => {
      this.cityData.forEach(city => {
        this.loadTownList(city)
      })
    }).then(r => {
      this.getData(this.param)
    }).catch(error => {
      console.error(error)
      this.$toasted.global.pop_error('查询失败')
    })
  },
  methods: {
    getData (param) {
      CameraApi.queryPage(param).then(resp => {
        resp.records.forEach(item => {
          item.selected = false
          this.loadItemCityData(item)
          this.loadItemCountyData(item)
          this.loadItemTownData(item)
        })
        this.cameraData = resp
      }).catch(error => {
        console.error(error)
        this.$toasted.global.pop_error('查询失败')
      })
    },

    loadCityList () {
      return PlaceApi.getCityList().then(resp => {
        resp.forEach(item => {
          item.value = item.city_code
          item.text = item.city_name
          if (!this.provinceMap[item.province_code]) {
            this.provinceMap[item.province_code] = {
              value: item.province_code,
              text: item.province_name,
              cityList: []
            }
          }
          this.provinceMap[item.province_code].cityList.push(item)
        })
        this.provinceData = Object.keys(this.provinceMap).map(item => this.provinceMap[item])
        this.cityData = resp
      })
    },
    loadTownList (city) {
      let cityCode = city.city_code
      this.cityMap[cityCode] = {
        countyList: []
      }
      let countyList = this.cityMap[cityCode].countyList
      PlaceApi.getPlaceList({
        city_code: cityCode
      }).then(resp => {
        resp.forEach(town => {
          if (!this.countyMap[town.county_code]) {
            this.countyMap[town.county_code] = {
              townList: [],
              value: town.county_code,
              text: town.county_name
            }
            countyList.push({
              value: town.county_code,
              text: town.county_name
            })
          }
          this.countyMap[town.county_code].townList.push({
            value: town.town_code,
            text: town.town_name,
            town_id: town.id
          })
        })
      }).catch(error => {
        console.error(error)
        this.$toasted.global.pop_error('加载片区信息失败')
      })
    },
    loadItemCityData (item) {
      item.cityData = this.provinceMap[item.province].cityList
    },
    loadItemCountyData (item) {
      let city = this.cityMap[item.city]
      item.countyData = city.countyList
    },
    loadItemTownData (item) {
      let m = this.countyMap[item.county]
      item.townData = m ? m.townList : []
    },
    pageChange (val) {
      this.param.page_no = val
      this.getData(this.param)
    },
    changeTown (item) {
      let town = item.townData.filter(x => x.value === item.town)
      item.town_id = town ? town[0].town_id : 0
    },
    selectAll () {
      this.cameraData.records.forEach(r => r.selected = true)
    },
    shiftAll () {
      this.cameraData.records.forEach(r => r.selected = !r.selected)
    },
    newRecord () {
      let item = {
        id: undefined,
        province: this.provinceData[0].value
      }
      item.cityData = this.provinceMap[item.province].cityList
      item.city = item.cityData[0].value
      item.countyData = this.cityMap[item.city].countyList
      item.county = item.countyData[0].value
      item.townData = this.countyMap[item.county].townList
      item.town = item.townData[0].value
      this.cameraData.records.unshift(item)
    },
    save (item) {
      if (!item.town_id) {
        this.changeTown(item)
      }
      if (item.lon < -180 || item.lon > 180) {
        this.$toasted.global.pop_error('经度合理范围为-180~180')
        return
      }
      if (item.lat < -90 || item.lat > 90) {
        this.$toasted.global.pop_error('纬度合理范围为-90~90')
        return
      }
      let data = Tool.cloneObject(item, ['id', 'imei', 'lon', 'lat', 'town_id',
        'province', 'city', 'county', 'town', 'village', 'place', 'scope'])
      CameraApi.save(data).then(resp => {
        if (Tool.returnSuccess(resp)) {
          this.$toasted.global.pop_success('保存成功')
          this.getData(this.param)
        } else {
          this.$toasted.global.pop_error(resp.msg)
        }
      }).catch(error => {
        console.error(error)
        this.$toasted.global.pop_error('保存失败')
      })
    },
    delOne (item, index) {
      if (!confirm(`确认删除记录${item.imei || ''}吗?`)) {
        return
      }
      if (!item.id) {
        this.cameraData.records.splice(index, 1)
      } else {
        this.del([item.id])
      }
    },
    delSelected () {
      let items = this.cameraData.records
      let ids = items.filter(item => item.selected).map(item => item.ids)
      for (let i = 0; i < ids.length; ++i) {
        if (!ids[i]) {
          items.splice(0, 1)
        }
      }
      ids = ids.filter(id => id)
      if (ids.length === 0) {
        return
      }
      this.del(ids)
    },
    del (ids) {
      if (!ids || ids.length === 0) {
        return
      }
      CameraApi.del(ids).then(resp => {
        this.getData(this.param)
      }).catch(error => {
        console.error(error)
        this.$toasted.global.pop_error('删除失败')
      })
    }
  },
  watch: {
  }

}
</script>
<style lang="scss" scoped>

</style>
